import { Box, Text } from '@rbilabs/universal-components';

import { ZIndex, primitive } from 'styles/constants';

export const RibbonWrapper = Box.withConfig({
  zIndex: ZIndex.MAX,
});

export const RibbonContent = Box.withConfig({
  zIndex: ZIndex.NORMAL,
  backgroundColor: primitive.$meltyYellow,
  height: '$8',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledRibbon = Text.withConfig({
  fontFamily: 'Flame-Regular',
  fontSize: 'xs',
  color: primitive.$bbqBrown,
  lineHeight: 'xs',
  textAlign: 'center',
  paddingX: '$3',
  zIndex: ZIndex.MAX,
});
